/**
 * Canonical form of the `email` attribute we hand to Optimizely.
 *
 * Optimizely audience conditions compare strings byte for byte, so an allow-list
 * entry typed with different casing or a trailing space silently fails to match
 * the member and the flag resolves to false with no error anywhere - which is how
 * members were missed on the AI Coach beta list. Normalising here means every
 * decision compares one canonical form; the audience entries themselves must be
 * lowercase for it to line up.
 */
export function normalizeOptimizelyEmail(email?: string): string {
  return email?.trim().toLowerCase() ?? '';
}
